<template>
  <div class="card kpi" :class="{ 'kpi--primary': primary, 'kpi--warn': warn, 'kpi--danger': danger }">
    <div class="kpi__head">
      <div class="kpi__label">{{ label }}</div>
      <i v-if="icon" :class="icon" class="kpi__icon"></i>
    </div>
    <div class="kpi__value">
      <span v-if="!loading">{{ formattedValue }}</span>
      <i v-else class="fas fa-spinner fa-spin"></i>
    </div>
    <div v-if="hint" class="kpi__hint">{{ hint }}</div>
  </div>
</template>

<script>
export default {
  name: 'CardKpi',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: 0 },
    suffix: { type: String, default: '' },
    icon: { type: String, default: '' },
    hint: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    warn: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
    decimal: { type: Number, default: 0 }
  },
  computed: {
    formattedValue () {
      const v = this.value
      if (v === null || v === undefined || v === '') return '—'
      if (typeof v === 'number') {
        return v.toLocaleString('pt-BR', {
          minimumFractionDigits: this.decimal,
          maximumFractionDigits: this.decimal
        }) + (this.suffix || '')
      }
      return v + (this.suffix || '')
    }
  }
}
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 6px;
  padding: 14px 14px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  height: 100%;
  box-sizing: border-box;
}
.kpi__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.kpi__label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.60);
  text-transform: uppercase;
}
.kpi__icon {
  color: rgba(0, 0, 0, 0.35);
  font-size: 14px;
}
.kpi__value {
  font-size: 22px;
  font-weight: 700;
  margin-top: 6px;
  color: rgba(0, 0, 0, 0.87);
}
.kpi__hint {
  font-size: 12px;
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.50);
}
.kpi--primary { border-left: 4px solid #346daa; }
.kpi--warn { border-left: 4px solid #f5a623; }
.kpi--danger { border-left: 4px solid #d0021b; }
</style>
